module.exports = __webpack_public_path__ + "img/logo-jadid.55832ceb.png";